var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiccProjectCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 390",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Global Intelligence Command Center \u2014 project card") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "A dark-themed project card showing the GICC dashboard with a stylized globe, signal markers, and tech stack badges."), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "globeGrad",
    cx: "42%",
    cy: "38%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a3a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#0a1e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#04101f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowPulse",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8b5cf6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8b5cf6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowPink",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d946ef",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d946ef",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cardClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 380,
    rx: 12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imagine-text-gaps-ja9a0r",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 390,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.49867248535156,
    y: 143.49990844726562,
    width: 13.002648830413818,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.49867248535156,
    y: 208.4999237060547,
    width: 13.002648830413818,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7753601074219,
    y: 169.44436645507812,
    width: 12.44925832748413,
    height: 13.444528579711914,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.05206298828125,
    y: 225.86105346679688,
    width: 11.895868062973022,
    height: 11.555623054504395,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.0568542480469,
    y: 30.499923706054688,
    width: 57.886295318603516,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 54.58317184448242,
    width: 57.99697494506836,
    height: 27.139095306396484,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 80.08323669433594,
    width: 188.34622192382812,
    height: 16.349453926086426,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 111.66656494140625,
    width: 32.681209564208984,
    height: 18.16679286956787,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 233.49990844726562,
    width: 119.32735443115234,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 246.47207641601562,
    width: 28.017974853515625,
    height: 24.777963638305664,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.9999694824219,
    y: 253.08323669433594,
    width: 37.942108154296875,
    height: 16.27788734436035,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 297.4999084472656,
    width: 72.28919982910156,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.0037536621094,
    y: 317.49993896484375,
    width: 43.99250793457031,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.7572021484375,
    y: 317.49993896484375,
    width: 50.48562240600586,
    height: 14.427372932434082,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.7598266601562,
    y: 317.49993896484375,
    width: 40.480323791503906,
    height: 14.396648406982422,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.3300170898438,
    y: 317.49993896484375,
    width: 23.339981079101562,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.75592041015625,
    y: 340.4999084472656,
    width: 38.48811912536621,
    height: 14.396648406982422,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.7598571777344,
    y: 340.4999084472656,
    width: 40.480323791503906,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.5059204101562,
    y: 340.4999084472656,
    width: 46.988197326660156,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.0074462890625,
    y: 340.4999084472656,
    width: 43.985130310058594,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 364.4999084472656,
    width: 211.40415954589844,
    height: 14.388981819152832,
    fill: "black",
    rx: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 380,
    rx: 12,
    fill: "#07101f",
    style: {
      fill: "rgb(7, 16, 31)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 380,
    rx: 12,
    fill: "none",
    stroke: "#1e3a5f",
    strokeWidth: 1,
    style: {
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cardClip)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 25,
    r: 1,
    fill: "#ffffff",
    opacity: 0.4,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 60,
    r: 0.8,
    fill: "#ffffff",
    opacity: 0.3,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 15,
    r: 1.2,
    fill: "#ffffff",
    opacity: 0.5,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 40,
    r: 0.7,
    fill: "#ffffff",
    opacity: 0.35,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.35,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 30,
    r: 1,
    fill: "#ffffff",
    opacity: 0.4,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 80,
    r: 0.8,
    fill: "#ffffff",
    opacity: 0.3,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 15,
    r: 1.1,
    fill: "#ffffff",
    opacity: 0.45,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.45,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 50,
    r: 0.9,
    fill: "#ffffff",
    opacity: 0.3,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 200,
    r: 0.8,
    fill: "#ffffff",
    opacity: 0.25,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 200,
    r: 1,
    fill: "#ffffff",
    opacity: 0.3,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 20,
    r: 0.7,
    fill: "#ffffff",
    opacity: 0.3,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 355,
    r: 0.9,
    fill: "#ffffff",
    opacity: 0.25,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 340,
    r: 0.8,
    fill: "#ffffff",
    opacity: 0.2,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.2,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 195,
    r: 155,
    fill: "url(#globeGrad)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 130 Q170 120 190 125 Q210 122 225 135 Q235 148 230 165 Q220 180 205 185 Q190 195 175 188 Q160 178 155 162 Z",
    fill: "#0f2d4a",
    opacity: 0.7,
    style: {
      fill: "rgb(15, 45, 74)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 200 Q200 195 212 205 Q220 220 218 240 Q215 260 200 270 Q185 265 178 250 Q172 232 178 215 Z",
    fill: "#0f2d4a",
    opacity: 0.7,
    style: {
      fill: "rgb(15, 45, 74)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 120 Q280 115 295 122 Q308 132 305 150 Q300 168 285 172 Q272 168 265 155 Q260 138 265 120 Z",
    fill: "#0f2d4a",
    opacity: 0.65,
    style: {
      fill: "rgb(15, 45, 74)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.65,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 178 Q285 172 298 182 Q310 198 305 220 Q298 240 280 245 Q265 240 260 222 Q255 200 270 178 Z",
    fill: "#0f2d4a",
    opacity: 0.6,
    style: {
      fill: "rgb(15, 45, 74)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 195,
    rx: 155,
    ry: 30,
    fill: "none",
    stroke: "#1e3a5f",
    strokeWidth: 0.5,
    opacity: 0.6,
    style: {
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 155,
    rx: 140,
    ry: 22,
    fill: "none",
    stroke: "#1e3a5f",
    strokeWidth: 0.4,
    opacity: 0.4,
    style: {
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.4px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 235,
    rx: 140,
    ry: 22,
    fill: "none",
    stroke: "#1e3a5f",
    strokeWidth: 0.4,
    opacity: 0.4,
    style: {
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.4px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 42 Q295 105 300 195 Q295 285 240 348",
    fill: "none",
    stroke: "#1e3a5f",
    strokeWidth: 0.4,
    opacity: 0.5,
    style: {
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.4px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 42 Q185 105 180 195 Q185 285 240 348",
    fill: "none",
    stroke: "#1e3a5f",
    strokeWidth: 0.4,
    opacity: 0.5,
    mask: "url(#imagine-text-gaps-ja9a0r)",
    style: {
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.4px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 195,
    r: 155,
    fill: "none",
    stroke: "#1d4ed8",
    strokeWidth: 1.5,
    opacity: 0.4,
    style: {
      fill: "none",
      stroke: "rgb(29, 78, 216)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 195,
    r: 158,
    fill: "none",
    stroke: "#3b82f6",
    strokeWidth: 0.5,
    opacity: 0.2,
    style: {
      fill: "none",
      stroke: "rgb(59, 130, 246)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.2,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 150,
    r: 28,
    fill: "url(#glowPulse)",
    opacity: 0.8,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 150,
    r: 16,
    fill: "url(#glowPulse)",
    opacity: 0.9,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 215,
    r: 22,
    fill: "url(#glowPink)",
    opacity: 0.8,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 215,
    r: 12,
    fill: "url(#glowPink)",
    opacity: 0.9,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 175,
    r: 18,
    fill: "url(#glowPulse)",
    opacity: 0.75,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.75,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 175,
    r: 10,
    fill: "url(#glowPulse)",
    opacity: 0.9,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 230,
    r: 14,
    fill: "url(#glowPink)",
    opacity: 0.7,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 230,
    r: 8,
    fill: "url(#glowPink)",
    opacity: 0.85,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.85,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 150,
    r: 9,
    fill: "#9333ea",
    opacity: 0.95,
    style: {
      fill: "rgb(147, 51, 234)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.95,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 154,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 215,
    r: 8,
    fill: "#c026d3",
    opacity: 0.95,
    style: {
      fill: "rgb(192, 38, 211)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.95,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 219,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 175,
    r: 7,
    fill: "#7c3aed",
    opacity: 0.95,
    style: {
      fill: "rgb(124, 58, 237)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.95,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 179,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 8,
    fontWeight: 600,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 8,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 230,
    r: 6,
    fill: "#a21caf",
    opacity: 0.95,
    style: {
      fill: "rgb(162, 28, 175)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.95,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 234,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 7,
    fontWeight: 600,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 7,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "1"), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 28,
    width: 62,
    height: 18,
    rx: 4,
    fill: "#7f1d1d",
    opacity: 0.9,
    style: {
      fill: "rgb(127, 29, 29)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 461,
    y: 41,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#fca5a5",
    style: {
      fill: "rgb(252, 165, 165)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "\u25CF CRITICAL"), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 75,
    fontFamily: "sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#ffffff",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 20,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "GICC"), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 92,
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#64748b",
    style: {
      fill: "rgb(100, 116, 139)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Global Intelligence Command Center"), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 125,
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#94a3b8",
    letterSpacing: 0.5,
    style: {
      fill: "rgb(148, 163, 184)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "v1.1"), /*#__PURE__*/React.createElement("foreignObject", {
    x: 430,
    y: 136,
    width: 228,
    height: 80,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      fontFamily: "sans-serif",
      fontSize: 12,
      color: "#cbd5e1",
      lineHeight: 1.6,
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(203, 213, 225)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "\n        Real-time geopolitical &amp; financial intelligence dashboard with an interactive 3D WebGL globe, live crisis signal monitoring, and AI-powered cross-signal analysis.\n      ")), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 228,
    width: 228,
    height: 52,
    rx: 6,
    fill: "#0f172a",
    stroke: "#1e293b",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(15, 23, 42)",
      stroke: "rgb(30, 41, 59)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 244,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#475569",
    letterSpacing: 0.8,
    style: {
      fill: "rgb(71, 85, 105)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "FEAR &amp; GREED INDEX"), /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 265,
    fontFamily: "sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#f97316",
    style: {
      fill: "rgb(249, 115, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 18,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "35"), /*#__PURE__*/React.createElement("text", {
    x: 473,
    y: 265,
    fontFamily: "sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#f97316",
    style: {
      fill: "rgb(249, 115, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 11,
      fontWeight: 600,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, " FEAR"), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 256,
    width: 130,
    height: 5,
    rx: 2.5,
    fill: "#1e293b",
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 256,
    width: 35,
    height: 5,
    rx: 2.5,
    fill: "#f97316",
    style: {
      fill: "rgb(249, 115, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 308,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#475569",
    letterSpacing: 0.8,
    style: {
      fill: "rgb(71, 85, 105)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "TECH STACK"), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 316,
    width: 48,
    height: 17,
    rx: 3,
    fill: "#1e3a5f",
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 454,
    y: 328,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#93c5fd",
    style: {
      fill: "rgb(147, 197, 253)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "React 18"), /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 316,
    width: 42,
    height: 17,
    rx: 3,
    fill: "#1e3a5f",
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 328,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#93c5fd",
    style: {
      fill: "rgb(147, 197, 253)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "TypeScript"), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 316,
    width: 36,
    height: 17,
    rx: 3,
    fill: "#1e3a5f",
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 328,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#93c5fd",
    style: {
      fill: "rgb(147, 197, 253)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Three.js"), /*#__PURE__*/React.createElement("rect", {
    x: 574,
    y: 316,
    width: 36,
    height: 17,
    rx: 3,
    fill: "#1e3a5f",
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 592,
    y: 328,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#93c5fd",
    style: {
      fill: "rgb(147, 197, 253)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Vite"), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 339,
    width: 46,
    height: 17,
    rx: 3,
    fill: "#1a2e1a",
    style: {
      fill: "rgb(26, 46, 26)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 453,
    y: 351,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#86efac",
    style: {
      fill: "rgb(134, 239, 172)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Node.js"), /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 339,
    width: 46,
    height: 17,
    rx: 3,
    fill: "#1a2e1a",
    style: {
      fill: "rgb(26, 46, 26)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 351,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#86efac",
    style: {
      fill: "rgb(134, 239, 172)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Express"), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 339,
    width: 50,
    height: 17,
    rx: 3,
    fill: "#2a1a2e",
    style: {
      fill: "rgb(42, 26, 46)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 559,
    y: 351,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#d8b4fe",
    style: {
      fill: "rgb(216, 180, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Gemini AI"), /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 339,
    width: 46,
    height: 17,
    rx: 3,
    fill: "#1a2a2e",
    style: {
      fill: "rgb(26, 42, 46)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 613,
    y: 351,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#67e8f9",
    style: {
      fill: "rgb(103, 232, 249)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Recharts"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362,
    width: 680,
    height: 18,
    fill: "#04101f",
    style: {
      fill: "rgb(4, 16, 31)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 375,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#334155",
    style: {
      fill: "rgb(51, 65, 85)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 9,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "84 SIGNALS ACTIVE  \xB7  LIVE FEED  \xB7  WebGL Globe"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 380,
    fill: "url(#scanlines)",
    opacity: 0.04,
    rx: 12,
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.04,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiccProjectCard);
export default __webpack_public_path__ + "static/media/gicc_project_card.bc29d33a69a8aa22421da835ed927e5c.svg";
export { ForwardRef as ReactComponent };